import { SET_USER_DETAIL } from "@/store/mutation.type";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class UserDetailMixin extends Vue {
    get userDetail() {
        return this.$store.state["user-detail"].userDetail
    }
    set userDetail(detail: any) {
        this.$store.commit(SET_USER_DETAIL, detail);
    }
}
